const newCustomer = {
  snackbar: "Your update is ready",
  name: "Customer Name",
  save: "Save",
  cancel: "Cancel",
  area: "Customer",
  formTitle: "Customer",
  confirm: "Are you sure you want to delete this item?",
  close: "Close",
  delete: "Delete"
};
export default newCustomer;
